'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _context = require('./context');

var _constants = require('../../libs/constants');

var _utils = require('./utils');

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toArray(arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var RIGHT_SIDE = 1;
var LEFT_SIDE = -1;
/**
* Tabs make it easy to explore and switch between different views.
* @category Layout
*/

var Tabset = function (_Component) {
  _inherits(Tabset, _Component);

  function Tabset(props) {
    var _this$keyHandlerMap;

    _classCallCheck(this, Tabset);

    var _this = _possibleConstructorReturn(this, (Tabset.__proto__ || Object.getPrototypeOf(Tabset)).call(this, props));

    _this.state = {
      tabChildren: []
    };
    _this.containerRef = _react2.default.createRef();
    _this.registerTab = _this.registerTab.bind(_this);
    _this.unRegisterTab = _this.unRegisterTab.bind(_this);
    _this.handleKeyPressed = _this.handleKeyPressed.bind(_this);
    _this.keyHandlerMap = (_this$keyHandlerMap = {}, _defineProperty(_this$keyHandlerMap, _constants.RIGHT_KEY, function () {
      return _this.selectTab(RIGHT_SIDE);
    }), _defineProperty(_this$keyHandlerMap, _constants.LEFT_KEY, function () {
      return _this.selectTab(LEFT_SIDE);
    }), _this$keyHandlerMap);
    return _this;
  }

  _createClass(Tabset, [{
    key: 'getContainerClassName',
    value: function getContainerClassName() {
      var _props = this.props,
          className = _props.className,
          fullWidth = _props.fullWidth;
      return (0, _classnames2.default)('rainbow-tabset', {
        'rainbow-tabset--full-width': fullWidth
      }, className);
    }
  }, {
    key: 'setAsSelectedTab',
    value: function setAsSelectedTab(tabIndex) {
      var tabChildren = this.state.tabChildren;
      tabChildren[tabIndex].ref.click();
      tabChildren[tabIndex].ref.focus();
    }
  }, {
    key: 'handleKeyPressed',
    value: function handleKeyPressed(event) {
      if (this.keyHandlerMap[event.keyCode]) {
        return this.keyHandlerMap[event.keyCode]();
      }

      return null;
    }
  }, {
    key: 'selectTab',
    value: function selectTab(side) {
      var activeTabName = this.props.activeTabName;
      var tabChildren = this.state.tabChildren;
      var tabIndex = tabChildren.findIndex(function (tab) {
        return tab.name === activeTabName;
      });

      if (tabIndex === tabChildren.length - 1 && side === RIGHT_SIDE) {
        this.setAsSelectedTab(0);
      } else if (tabIndex === 0 && side === LEFT_SIDE) {
        this.setAsSelectedTab(tabChildren.length - 1);
      } else {
        this.setAsSelectedTab(tabIndex + side);
      }
    }
  }, {
    key: 'registerTab',
    value: function registerTab(tab) {
      var tabChildren = this.state.tabChildren;

      var _getChildTabNodes = (0, _utils.getChildTabNodes)(this.containerRef.current),
          _getChildTabNodes2 = _toArray(_getChildTabNodes),
          nodes = _getChildTabNodes2.slice(0);

      var newChildrenRefs = (0, _utils.insertChildOrderly)(tabChildren, tab, nodes);
      this.setState({
        tabChildren: newChildrenRefs
      });
    }
  }, {
    key: 'unRegisterTab',
    value: function unRegisterTab(tabName) {
      var tabChildren = this.state.tabChildren;
      var newTabChildren = tabChildren.filter(function (t) {
        return t.name !== tabName;
      });
      this.setState({
        tabChildren: newTabChildren
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          onSelect = _props2.onSelect,
          activeTabName = _props2.activeTabName,
          fullWidth = _props2.fullWidth,
          children = _props2.children,
          style = _props2.style;
      return _react2.default.createElement('ul', {
        id: id,
        className: this.getContainerClassName(),
        style: style,
        role: 'tablist',
        onKeyDown: this.handleKeyPressed,
        ref: this.containerRef
      }, _react2.default.createElement(_context.Provider, {
        value: {
          activeTabName: activeTabName,
          onSelect: onSelect,
          privateRegisterTab: this.registerTab,
          privateUnRegisterTab: this.unRegisterTab,
          fullWidth: fullWidth
        }
      }, children));
    }
  }]);

  return Tabset;
}(_react.Component);

exports.default = Tabset;
Tabset.propTypes = {
  /** The name of the tab that is selected. It must match the name of the tab. */
  activeTabName: _propTypes2.default.node,

  /** Action fired when an item is selected.
   * The event params include the `name` of the selected item. */
  onSelect: _propTypes2.default.func,

  /** If true, the tabs will grow to use all the available space.
  * This value defaults to false. */
  fullWidth: _propTypes2.default.bool,

  /** The id of the outer element. */
  id: _propTypes2.default.string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes2.default.object,

  /**
  * This prop that should not be visible in the documentation.
  * @ignore
  */
  children: _propTypes2.default.node
};
Tabset.defaultProps = {
  activeTabName: undefined,
  onSelect: function onSelect() {},
  fullWidth: false,
  className: undefined,
  style: undefined,
  children: null,
  id: undefined
};